import { render, staticRenderFns } from "./questionnaireDetail.vue?vue&type=template&id=8b59453c&scoped=true"
import script from "./questionnaireDetail.vue?vue&type=script&lang=js"
export * from "./questionnaireDetail.vue?vue&type=script&lang=js"
import style0 from "./questionnaireDetail.vue?vue&type=style&index=0&id=8b59453c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b59453c",
  null
  
)

export default component.exports